/**
 * Create here the functions that generate URLs for the product filters in filterHelper.js
 */

/**
 * @param {string} pathname The pathname extracted from the full url
 * @param {string} word The path should be extracted up to and including this word
 * @returns The path extracted up to and including the word
 *
 * @example
 * extractPartialPath('/en/moorings/', 'moorings') // returns '/en/moorings/'
 * extractPartialPath('/ligplaatsen/', 'ligplaatsen') // returns '/ligplaatsen/'
 * extractPartialPath('/en/moorings/', 'boats') // returns null
 */
export const extractPartialPath = (pathname, word) => {
  // Handle null/undefined inputs
  if (!pathname || !word) {
    return null;
  }

  // Handle empty string word
  if (word.trim() === '') {
    return null;
  }

  try {
    const match = pathname.match(new RegExp(`(/(?:[a-z]{2}/)?${word})/?`));
    return match?.[1] ?? null;
  } catch (error) {
    return null;
  }
};

/**
 * @param {string} pathname The pathname extracted from the full url
 * @param {string[]} productNames A list of product names (different languages)
 * @returns The path extracted from the pathname up to and including the first word in the productNames array
 *
 */
export const extractProductPath = (pathname, productNames) => {
  if (!pathname || !productNames) {
    return null;
  }

  if (!Array.isArray(productNames) || productNames.length === 0) {
    return null;
  }

  for (const productName of productNames) {
    if (!productName || productName.trim() === '') {
      continue;
    }

    if (pathname.includes(`/${productName}`)) {
      return extractPartialPath(pathname, productName);
    }
  }
  return null;
};
